import React from 'react';

const LoadingScreen: React.FC = () => {
  return (
    <div className="min-h-screen flex justify-center items-center md:py-6">
      <div className="w-full max-w-[668px] h-[70vh] md:mx-4 flex flex-col items-center justify-center">
        <div className="flex flex-col items-center">
          {/* Logo */}
          <h1 className="text-white font-black uppercase leading-none">
            <span>WHICH</span>{' '}
            <span className="text-[#C6A4FF] ml-[-2px]">YEAR</span>
          </h1>

          {/* Absolute minimal spinner */}
          <span className="loader"></span>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
